/**
 * Which message a single status line shows when several things are wrong.
 *
 * The editor has one status line and several sources that write to it, and
 * they ran into each other: a routine save cycle cleared whatever was there.
 * Since autosave fires `saving → saved` roughly five seconds after any edit, an
 * export failure written to that line survived only until the user drew the
 * next thing — which is worse than not reporting it, because it looks reported.
 *
 * So each source owns a slot and clears only its own, and the line shows the
 * most serious outstanding one.
 *
 * The order is by how much the user stands to lose:
 *   load    — the drawing never opened; nothing else is even true yet
 *   save    — their work is not on the server
 *   edit    — the engine refused the edit being attempted right now
 *   export  — a file they asked for did not arrive; the drawing is fine
 */
export const STATUS_SOURCES = ["load", "save", "edit", "export"]

/**
 * @param {Record<string, string>} slots message per source; "" or absent = quiet
 * @returns {string} the message to show, or "" when nothing is wrong
 */
export function mostSeriousMessage(slots) {
  for (const source of STATUS_SOURCES) {
    const message = slots[source]
    if (message) return message
  }

  return ""
}
